import { Controller } from 'stimulus'
import 'custom-event-polyfill'

/**
 * @namespace RemovablePill
 */
export default class extends Controller {
  get pillValue() {
    return this.element.getAttribute('data-pill-value')
  }

  /**
     * If this pill has a sibling, flag that sibling's button as the next element to receive browser focus.
     * If this pill has no siblings, flag that, instead.
     */
  determineElementToFocus() {
    const previousSibling = $(this.element).prev()
    const nextSibling = $(this.element).next()
    if (previousSibling.length > 0) {
      this.elementToFocus = previousSibling.find('button')
    } else if (nextSibling.length > 0) {
      this.elementToFocus = nextSibling.find('button')
    } else {
      this.elementToFocus = null
    }
  }

  removePillInput() {
    const input = this.element.querySelector(`input[id="removable-pill-input-${this.pillValue}"]`)

    $(input).remove()
  }

  /**
     * Identify the element that should receive focus next, and then destroy this DOM element.
     */
  removePill() {
    this.determineElementToFocus()
    this.parent = $(this.element).parent()
    $(this.element).remove()
    window.dispatchEvent(new CustomEvent('refresh-pills', {
      detail: {
        pillRemovableParent: $(this.element).data('index')
      }
    }))
  }
}
